import axios from 'axios';
import { createHeaders } from './headerUtils';

const BASE_URL = process.env.REACT_APP_BASE_URL;

const getDefaultDateRange = () => {
	const toDate = new Date();
	const fromDate = new Date(toDate.getTime() - 7 * 24 * 60 * 60 * 1000);
	return {
		from: fromDate.toISOString(),
		to: toDate.toISOString(),
	};
};

const buildSearchPayload = ({
	freeText = '',
	email = '',
	domain = '',
	accountId = '',
	ticketsOnly = false,
	conversationId = '',
	conversationStatus = '',
	ticketId = '',
	ticketOpen = '',
	ticketStateCategory = '',
	includeDateRange = true,
	from = '',
	to = '',
	page,
	size,
} = {}) => {
	const defaultDateRange = getDefaultDateRange();
	const payload = {
		query: {
			ticketsOnly: Boolean(ticketsOnly),
		},
	};

	if (page !== undefined && size !== undefined) {
		payload.query.paging = { page, size };
	}

	if (includeDateRange) {
		payload.query.dateRange = {
			from: from || defaultDateRange.from,
			to: to || defaultDateRange.to,
		};
	} else {
		payload.query.dateRange = { from: null, to: null };
	}

	if (email) payload.query.email = email;
	if (freeText) payload.query.freeText = freeText;
	if (domain) payload.query.domain = domain;
	if (accountId) payload.query.accountId = accountId;

	if (conversationId || conversationStatus) {
		payload.query.conversation = {};
		if (conversationId) payload.query.conversation.id = conversationId;
		if (conversationStatus) payload.query.conversation.status = conversationStatus;
	}

	if (ticketId || ticketOpen !== '' || ticketStateCategory) {
		payload.query.ticket = {};
		if (ticketId) payload.query.ticket.id = ticketId;
		if (ticketOpen !== '') payload.query.ticket.open = ticketOpen;
		if (ticketStateCategory) {
			payload.query.ticket.state = { category: ticketStateCategory };
		}
	}

	return payload;
};

const intercomV2Service = {
	searchConversations: async (filters = {}) => {
		try {
			const payload = buildSearchPayload({
				...filters,
				page: filters.page ?? 1,
				size: filters.size ?? 20,
			});

			const headers = createHeaders();
			const apiUrls = [
				`${BASE_URL}/intercom/search`,
				`${BASE_URL}/intercom/search/conversations`,
			];

			let lastError;
			for (const apiUrl of apiUrls) {
				try {
					const response = await axios.post(apiUrl, payload, { headers });
					return response.data;
				} catch (error) {
					lastError = error;
					if (error?.response?.status !== 404) {
						throw error;
					}
				}
			}

			throw lastError;
		} catch (error) {
			console.log('intercomV2Service (ERROR): searchConversations', error.message);
			throw error;
		}
	},

	exportConversations: async (filters = {}) => {
		try {
			const { page, size, ...rest } = filters;
			const payload = buildSearchPayload(rest);
			const headers = createHeaders();
			const response = await axios.post(
				`${BASE_URL}/intercom/search/export`,
				payload,
				{ headers }
			);
			return response.data;
		} catch (error) {
			console.log('intercomV2Service (ERROR): exportConversations', error.message);
			throw error;
		}
	},
};

export default intercomV2Service;
